// extracted by mini-css-extract-plugin
export default {"downloadSectionImage":"styles_downloadSectionImage__gfbFI","downloadBadges":"styles_downloadBadges__oT4O3","icon":"styles_icon__WstSm","iconFullWidth":"styles_iconFullWidth__S1hti"};